/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-relay/~/lodash/_baseProperty.js
 ** module id = 610
 ** module chunks = 0
 **/